import React, { useState, useEffect } from "react";
import { Route, Routes, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { onSnapshot, collection, query, orderBy } from "firebase/firestore";
import { db } from "../../FirebaseConfig";
import Lists from "./Lists";

const Favorites = () => {
  // My Shopping list Data
  const [shoppingListData, setShoppingListData] = useState(null);
  const [activeAccordion, setActiveAccordion] = useState([]);
  const [loading, setLoading] = useState(true);
  const { uid } = useParams();

  useEffect(() => {
    const fetchFavorites = async () => {
      setLoading(true);

      if (!uid) {
        setLoading(false);
        return;
      }

      const favoritesRef = collection(db, "users", uid, "favorites");
      const q = query(
        favoritesRef,

        orderBy("timestamp", "desc") // Sort by timestamp descending
      );

      let unsubscribe;
      try {
        unsubscribe = onSnapshot(q, async (querySnapshot) => {
          const favoritesData = await Promise.all(
            querySnapshot.docs.map(async (document) => {
              const favorite = document.data();

              return {
                id: document.id,
                name: favorite.listName,
                timestamp: favorite.timestamp?.seconds || 0,
                products: favorite.products || [],
                productIds: favorite.productIds || [],
                type: favorite.type,
                ...favorite,
              };
            })
          );

          setShoppingListData(favoritesData);
        });
        setLoading(false);
      } catch (error) {
        console.error("Error fetching favorites:", error);
        toast.error("Failed to load favorites");
      } finally {
        setLoading(false);
      }

      return () => {
        if (unsubscribe) unsubscribe();
      };
    };

    window.scrollTo(0, 0);
    fetchFavorites();
  }, [uid]);

  return (
    <>
      {/* Nav Strip under Header */}

      <Routes>
        <Route
          path="/"
          element={
            <Lists
              shoppingListData={shoppingListData}
              setShoppingListData={setShoppingListData}
              loading={loading}
              activeAccordion={activeAccordion}
              setActiveAccordion={setActiveAccordion}
            />
          }
        />
      </Routes>
    </>
  );
};

export default Favorites;
